import D3EFeatureBundle from "./D3EFeatureBundle";
import DFile from "../classes/DFile";
import DBObject from "../utils/DBObject";
import CloneContext from "../utils/CloneContext";

export default class D3EFeature extends DBObject {
  private static readonly _ANDROIDSCREENSHOT: number = 0;
  private static readonly _BUNDLE: number = 1;
  private static readonly _DESCRIPTION: number = 2;
  private static readonly _ICON: number = 3;
  private static readonly _TITLE: number = 4;
  private static readonly _WEBSCREENSHOT: number = 5;
  public id: number = 0;
  public otherMaster: DBObject;
  private _title: string = "";
  private _icon: DFile = null;
  private _description: string = "";
  private _webScreenshot: DFile = null;
  private _androidScreenshot: DFile = null;
  private _bundle: D3EFeatureBundle = null;
  public constructor(
    d3eParams?: Partial<{
      androidScreenshot: DFile;
      bundle: D3EFeatureBundle;
      description: string;
      icon: DFile;
      title: string;
      webScreenshot: DFile;
    }>
  ) {
    super();

    this.setAndroidScreenshot(d3eParams?.androidScreenshot ?? null);

    this.setBundle(d3eParams?.bundle ?? null);

    this.setDescription(d3eParams?.description ?? "");

    this.setIcon(d3eParams?.icon ?? null);

    this.setTitle(d3eParams?.title ?? "");

    this.setWebScreenshot(d3eParams?.webScreenshot ?? null);
  }
  public get d3eType(): string {
    return "D3EFeature";
  }
  public clear(): void {
    this.d3eChanges.clear();
  }
  public get title(): string {
    return this._title;
  }
  public setTitle(val: string): void {
    let isValChanged: boolean = this._title !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(D3EFeature._TITLE, this._title);

    this._title = val;

    this.fire("title", this);
  }
  public get icon(): DFile {
    return this._icon;
  }
  public setIcon(val: DFile): void {
    let isValChanged: boolean = this._icon !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(D3EFeature._ICON, this._icon);

    this._icon = val;

    this.fire("icon", this);
  }
  public get description(): string {
    return this._description;
  }
  public setDescription(val: string): void {
    let isValChanged: boolean = this._description !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(D3EFeature._DESCRIPTION, this._description);

    this._description = val;

    this.fire("description", this);
  }
  public get webScreenshot(): DFile {
    return this._webScreenshot;
  }
  public setWebScreenshot(val: DFile): void {
    let isValChanged: boolean = this._webScreenshot !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(D3EFeature._WEBSCREENSHOT, this._webScreenshot);

    this._webScreenshot = val;

    this.fire("webScreenshot", this);
  }
  public get androidScreenshot(): DFile {
    return this._androidScreenshot;
  }
  public setAndroidScreenshot(val: DFile): void {
    let isValChanged: boolean = this._androidScreenshot !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(
      D3EFeature._ANDROIDSCREENSHOT,
      this._androidScreenshot
    );

    this._androidScreenshot = val;

    this.fire("androidScreenshot", this);
  }
  public get bundle(): D3EFeatureBundle {
    return this._bundle;
  }
  public setBundle(val: D3EFeatureBundle): void {
    let isValChanged: boolean = this._bundle !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(D3EFeature._BUNDLE, this._bundle);

    this.updateObservable("bundle", this._bundle, val);

    this._bundle = val;

    this.fire("bundle", this);
  }
  public get(field: number): any {
    switch (field) {
      case D3EFeature._TITLE: {
        return this._title;
      }

      case D3EFeature._ICON: {
        return this._icon;
      }

      case D3EFeature._DESCRIPTION: {
        return this._description;
      }

      case D3EFeature._WEBSCREENSHOT: {
        return this._webScreenshot;
      }

      case D3EFeature._ANDROIDSCREENSHOT: {
        return this._androidScreenshot;
      }

      case D3EFeature._BUNDLE: {
        return this._bundle;
      }
      default: {
        return null;
      }
    }
  }
  public updateD3EChanges(index: number, value: any): void {
    if (this.lockedChanges()) {
      return;
    }

    super.updateD3EChanges(index, value);
  }
  public restore(): void {
    /*
TODO: Might be removed
*/

    this.d3eChanges.restore(this);
  }
  public deepClone(clearId = true): D3EFeature {
    let ctx: CloneContext = new CloneContext({ "clearId": clearId });

    return ctx.startClone(this);
  }
  public collectChildValues(ctx: CloneContext): void {}
  public deepCloneIntoObj(dbObj: DBObject, ctx: CloneContext): void {
    let obj: D3EFeature = dbObj as D3EFeature;

    obj.id = this.id;

    obj.setTitle(this._title);

    obj.setIcon(this._icon);

    obj.setDescription(this._description);

    obj.setWebScreenshot(this._webScreenshot);

    obj.setAndroidScreenshot(this._androidScreenshot);

    obj.setBundle(this._bundle);
  }
  public set(field: number, value: any): void {
    switch (field) {
      case D3EFeature._TITLE: {
        this.setTitle(value as string);
        break;
      }

      case D3EFeature._ICON: {
        this.setIcon(value as DFile);
        break;
      }

      case D3EFeature._DESCRIPTION: {
        this.setDescription(value as string);
        break;
      }

      case D3EFeature._WEBSCREENSHOT: {
        this.setWebScreenshot(value as DFile);
        break;
      }

      case D3EFeature._ANDROIDSCREENSHOT: {
        this.setAndroidScreenshot(value as DFile);
        break;
      }

      case D3EFeature._BUNDLE: {
        this.setBundle(value as D3EFeatureBundle);
        break;
      }
    }
  }
}
